/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import $ from 'jquery';
import BaseControl from 'scripts/base-control';
import get from 'lodash/get';
import DomEventsManager from 'scripts/dom-events-manager';
import appContext from 'scripts/app-context';
import urlUtil from 'scripts/utils/url';
import domUtil from 'scripts/utils/dom';
import dtm from 'scripts/services/dtm';
import welcomeWidget from './welcome-widget.stache'
import {Gigya} from '../../../../transitive/js/usga.gigya';
import dayjs from 'dayjs';
import _ from 'lodash';
import LocalStorageService from 'scripts/services/localstorage-service';

const searchPagePath = get(window, 'globalSettings.pagePaths.search', '');

export const Navigation = BaseControl.extend({
    invokableAction: false,

    init: function () {
        this._super();
        Gigya.onReady(() => this.onGigyaActionsReady());

        this.screen = this.options.appContext.model.screen;

        this.navItemsMap = [];
        this.navMoreItemsMap = [];
        this.$header = this.$element.find('.s-header');
        this.$mainNavigation = this.$element.find('.s-header .js-main-navigation');
        this.$logo = this.$element.find('.s-header .js-logo');
        this.$additionalItems = this.$element.find('.s-header .js-additional-items');
        this.$navigation = this.$element.find('.s-header .js-navigation');
        this.$moreItem = this.$element.find('.s-header .js-nav-item-more');
        this.$navItemsWrapper = this.$element.find('.s-header .js-navigation-items-wrapper');
        this.$element.find('.s-header .js-nav-item').each((index, el) => {
            $(el).data('index', index).attr('data-index', index);
            this.navItemsMap.push(el);
        });
        this.$element.find('.s-header .js-more-item').each((index, el) => this.navMoreItemsMap.push(el));
        this.$welcomeWidgetContainer = this.$element.find('.js-welcome-widget');

        if (!this.$header.length) {
            this.$element.addClass('is-hidden-nav');
        }

        (this.screen.attr('screenSize') === 'large' || this.screen.attr('screenSize') === 'extra-large') && this.checkNavigationItemsCount();
        Gigya.onUser((data) => this.updateMenuItemsAccordingToAuthorizationState(data));

        if (this.$element.find('.s-ticker-container').length) {
            this.$element.addClass('has-ticker');
            this.$element.siblings('.m-navigation-placeholder').addClass('has-ticker');
            this.$tickerContainer = this.$element.find('.s-ticker-container')[0];
            this.renderTicker();
            window.addEventListener(
                "message",
                (e) => this.listenMessageFromIframe(e)
            );
        }

        DomEventsManager.subscribe(this);
    },

    renderTicker: function () {
        try {
            this.tickerData = $(this.$tickerContainer).data('tickers');

            $(this.$tickerContainer).append(`<div class="s-team-selection"></div>`);
            $(this.$tickerContainer).find('.s-team-selection').append(`<select class="ticker-dropdown"></select>`);
            const tickerDropdown = this.element.find('.ticker-dropdown')[0];

            let options = '';
            $.each(this.tickerData, function(key, name){
                const {championshipName, tickerSrc} = name;
                options += key === 0 ?`<option value="${tickerSrc}" class="s-item">
                        ${championshipName}
                    </option>` : `<option value="${tickerSrc}" class="s-item">
                        ${championshipName}
                    </option>`
            });
            $(tickerDropdown).html(options);
            const savedChampionship = LocalStorageService.getItem('ticker-championship');
            let tickerSrc = this.tickerData[0].tickerSrc;
            if (savedChampionship) {
                const matchIndex = this.tickerData.findIndex(({championshipName}) => savedChampionship === championshipName);
                if (matchIndex !== -1) {
                    tickerSrc = this.tickerData[matchIndex].tickerSrc;
                } else {
                    tickerSrc = this.tickerData[0].tickerSrc;
                }
            }

            $(tickerDropdown).val(tickerSrc);
            $(this.$tickerContainer).append(`<iframe src="${tickerSrc}" frameborder="0" class="s-ticker-iframe"></iframe>`)
            this.$tickerIframe = $(this.$tickerContainer).find('.s-ticker-iframe')[0];
        } catch (e) {
            console.log('e', e)
        }
    },

    listenMessageFromIframe: function (event) {
        try {
            const messageData = JSON.parse(event.data);
            if (messageData.messageType === 'ticker-highlight' && this.$tickerIframe) {
                this.changeTickerIframeHeight(messageData.eventType);
            }
        } catch (error) {
            console.log(error);
        }
    },

    changeTickerIframeHeight: function(eventType) {
        if (eventType === 'close-highlight') {

            $(this.$tickerIframe).removeClass('s-ticker-has-highlight')
        } else {
            $(this.$tickerIframe).addClass('s-ticker-has-highlight')
        }
    },

    sendMessageToIframe: function() {
        if (this.$tickerIframe) {
            $(this.$tickerIframe).removeClass('s-ticker-has-highlight');
            this.$tickerIframe.contentWindow.postMessage(JSON.stringify({
                messageType: 'ticker-highlight',
                eventType: 'close-highlight'
            }), '*');
        }
    },

    updateMenuItemsAccordingToAuthorizationState: function (response) {
        this.$element.toggleClass('is-user-logged-in', Gigya.isLoggedIn());

        const firstName = _.get(response, 'profile.firstName', '');
        const lastName = _.get(response, 'profile.lastName', '');
        const memberLevel = _.get(response, 'data.memberLevel', '');
        const expiryDate = _.get(response, 'data.memberExpDate', '');
        const expiryRemain = expiryDate ? dayjs(expiryDate, 'MM/DD/YYYY').fromNow() : '';
        const type = this.getUserType();
        const info = this.options[`${type}Info`];
        const data = {
            name: `${firstName} ${lastName}`.trim(),
            expiryDate,
            expiryRemain: expiryDate && dayjs(expiryDate, 'MM/DD/YYYY').isAfter() ? expiryRemain : '',
            memberLevel,
            type,
            isExpiredMember: Gigya.isExpiredMember(),
            info,
            buttons: _.get(info, 'buttons', []).filter(button => button.text === 'renew' ? Gigya.isExpiredMember() : true),
            expiredAlertMessage: this.options.alertMessage
        };
        this.$welcomeWidgetContainer.html(welcomeWidget(data));
    },

    getUserType: function () {
        if (Gigya.isFan()) {
            return 'fan';
        }

        if (Gigya.isMember()) {
            return 'member';
        }

        return 'anonymous';
    },

    isObject: function (obj) {
        var type = typeof obj;
        return type === 'function' || type === 'object' && !!obj;
    },

    getAuthorizationData: function () {
        var self = this;
        if (Gigya.isLoggedIn()) {
            var d = $.Deferred();

            Gigya.getDataStore(function (ds) {
                var obj = {};

                if (ds && self.isObject(ds) &&
                    ds.data && self.isObject(ds.data) &&
                    ds.data.membership && self.isObject(ds.data.membership)) {
                    obj = ds.data.membership;
                }
                return d.resolve(obj);
            });

            return d.promise();
        }
        else {
            return $.when(false);
        }
    },

    isGigyaAction: function (action) {
        return ['login', 'sign-in', 'logout', 'register', 'sign-up', 'profile', 'campaignRegister',
            'campaignLogin'].indexOf(action) !== -1;
    },

    invokeAction: function (name) {
        if (this.isGigyaAction(name)) {
            var gigyaActionMap = {
                'sign-in': 'campaignLogin',
                'sign-up': 'campaignRegister',
            };

            var action = Gigya[name] || Gigya[gigyaActionMap[name]];

            if (action) {
                action.apply(Gigya);
            }
        }
    },

    onGigyaActionsReady: function () {
        if (this.invokableAction) {
            this.invokeAction(this.invokableAction);
            this.invokableAction = false;
        }
    },

    onLayout: function (screen) {
        this.expandedItemIndex != null && this.itemClick(this.expandedItemIndex);
        screen === 'large' || screen === 'extra-large' ? this.bindDesktopEvents() : this.bindMobileEvents();
        if (screen === 'extra-small') {
            domUtil.trapFocusMultiplatform(this.$mainNavigation);
        }
    },

    bindDesktopEvents: function () {

        if (this.bindindDesktopEvents) {
            return;
        }

        if (this.bindindMobileEvents) {
            this.bindindMobileEvents.destroy();
            this.bindindMobileEvents = null;
        }

        const desktopEventsControl = this.can.Control.extend(this.desktopEvents(this)[0]);
        this.bindindDesktopEvents = new desktopEventsControl(this.$element);
    },

    bindMobileEvents: function () {
        if (this.bindindMobileEvents) {
            return;
        }

        if (this.bindindDesktopEvents) {
            this.bindindDesktopEvents.destroy();
            this.bindindDesktopEvents = null;
        }

        const mobileEventsControl = this.can.Control.extend(this.mobileEvents(this)[0]);
        this.bindindMobileEvents = new mobileEventsControl(this.$element);
    },

    onWindowResize: function () {
        if (this.screen.attr('screenSize') === 'large' || this.screen.attr('screenSize') === 'extra-large') this.checkNavigationItemsCount();
    },

    onScreenOrientation() {
        // Force repaint on iPad for the correct menu display
        this.$header.hide().show(0);
    },

    checkNavigationItemsCount: function () {
        const mainNavigationWidth = this.$mainNavigation.width();
        const logoWidth = this.$logo.outerWidth(true);
        const additionalItemsWidth = this.$additionalItems.outerWidth(true);

        const navigationWidth = mainNavigationWidth - logoWidth - additionalItemsWidth;
        const moreItemWidth = this.$moreItem.outerWidth();
        const itemsNumber = this.navItemsMap.length;
        let menuItemsWidth = 0;
        let isFit = true;

        this.navItemsMap.forEach((el, index) => {

            if (isFit) {
                const itemWidth = $(el).outerWidth();

                if (menuItemsWidth + itemWidth + (index === itemsNumber - 1 ? 0 : moreItemWidth) <= navigationWidth) {
                    $(el).removeClass('is-hidden');
                    $(this.navMoreItemsMap[index]).addClass('is-hidden');

                    menuItemsWidth += itemWidth;

                } else {
                    $(el).addClass('is-hidden');
                    $(this.navMoreItemsMap[index]).removeClass('is-hidden');

                    isFit = false;
                }
            } else {
                $(el).addClass('is-hidden');
                $(this.navMoreItemsMap[index]).removeClass('is-hidden');
            }
        });

        this.$moreItem.toggleClass('is-hidden', isFit);
        this.$navigation.addClass('loaded');
        this.$navItemsWrapper.css({'max-width': navigationWidth - 10});
    },

    desktopEvents: (context) => {
        function shouldTriggerDropdown (event) {
            const $target = $(event.target);
            if (!$target.is('.s-dropdown, .s-dropdown *')) {
                if (event.type === 'touchend' && !$target.is('a, a * ')) {
                    event.preventDefault();
                }
                return true;
            }
            return false;
        }

        function openNavItem (el, event) {
            if (shouldTriggerDropdown(event)) {
                const targetIndex = $(el.context).data('index');
                context.itemClick(targetIndex);
            }
        }

        function openNavMoreItem (el, event) {
            if (shouldTriggerDropdown(event)) {
                context.expandedItemIndex != null && $(context.navItemsMap[context.expandedItemIndex]).removeClass('is-expanded');
                context.expandedItemIndex = null;
                context.$moreItem.toggleClass('is-expanded');
            }
        }

        function itemMouseLeave (el) {
            $(el.context).removeClass('is-expanded');
        }

        return [{

            '.s-header .js-nav-item mouseenter': openNavItem,
            '.s-header .js-nav-item touchend': openNavItem,

            '.s-header .s-nav-item a.s-nav-title click': function (el) {
                const linkText = el.text().trim();
                dtm.trackGlobalNavigationSimpleLinkClick(linkText);
            },
            '.s-header .s-section--featured a click': function (el) {
                if (el.hasClass('s-card--promo')) {
                    dtm.trackGlobalNavigationPromoClick();
                } else {
                    dtm.trackGlobalNavigationFeatureClick();
                }
            },

            '.s-header .s-dropdown-content a click': function (el) {
                const content = el.closest('.s-dropdown-content');
                const sectionList = content.find('.s-section--list');
                const sectionListItem = el.closest('.s-section--list');
                const sectionLinks = sectionListItem.find('.s-list-item');
                const innerDropdownContent = el.closest('.s-inner-dropdown-content');
                const layout = content.data('layout');
                const linkName = el.text().trim().toLowerCase();

                let column = 1;
                let navigationPosition = '2nd';
                let linkPosition = sectionLinks.index(el) + 1;

                if (innerDropdownContent && innerDropdownContent.length) {
                    navigationPosition = '3rd';
                }

                if (layout === 'five-columns' || layout === 'four-columns') {
                    column = sectionList.index(sectionListItem) + 1;
                }

                if (linkPosition === 0) {
                    linkPosition = 1;
                }

                dtm.trackGlobalNavigationLinkClick(layout, column, navigationPosition, linkName, linkPosition);
            },

            '.s-header .js-nav-item mouseleave': itemMouseLeave,
            '.s-header .js-nav-item-more mouseenter': openNavMoreItem,
            '.s-header .js-nav-item-more touchend': openNavMoreItem,
            '.s-header .js-nav-item-more mouseleave': itemMouseLeave,

            '.s-header .js-nav-item-more click': function (el, event) {
                const isKeyPressed = event.originalEvent.detail === 0;
                if (isKeyPressed) {
                    openNavMoreItem(el, event);
                }
            },

            '.s-header .js-dropdown-title.js-more-item click': function (el) {
                const targetIndex = $(el.context).data('index');
                context.itemClick(targetIndex);
            },

            '.s-header .js-dropdown-title click': function (el, event) {
                const isKeyPressed = event.originalEvent.detail === 0;
                if (shouldTriggerDropdown(event) && isKeyPressed) {
                    const targetIndex = el.closest('.js-nav-item').data('index');
                    context.itemClick(targetIndex);
                }
            },

            '{document.body} touchstart': function (el, event) {
                // close dropdowns for tablets
                if (!$.contains(context.$navigation.get(0), event.target)) {
                    context.expandedItemIndex != null && $(context.navItemsMap[context.expandedItemIndex]).removeClass('is-expanded');
                    context.expandedItemIndex = null;
                    context.$moreItem.removeClass('is-expanded');
                }
            }
        }]
    },

    mobileEvents: (context) => [{

        '.s-header .js-dropdown-title click': function (el) {
            const targetIndex = $(el.context).closest('.js-nav-item').data('index');
            context.itemClick(targetIndex);
        },

        '.s-header .js-nav-item-more click': function () {
            context.expandedItemIndex != null && $(context.navItemsMap[context.expandedItemIndex]).removeClass('is-expanded');
            context.expandedItemIndex = null;
            context.$moreItem.toggleClass('is-expanded');
        },

        '.s-header .s-nav-item a.s-nav-title click': function (el) {
            const linkText = el.text().trim();
            dtm.trackGlobalNavigationSimpleLinkClick(linkText);
        },

        '.s-header .js-back-btn click': function (el) {
            const $navItem = $(el.context).closest('.js-nav-item');
            const targetIndex = $navItem.data('index');
            context.itemClick(targetIndex);
            if ($navItem.find('.js-dropdown-title')) {
                $navItem.find('.js-dropdown-title').focus();
            }
        },

        '.s-header .js-inner-dropdown-title click': function (el) {
            const target = $(el.context).closest('.js-inner-item');
            target.addClass('is-expanded');
        },

        '.s-header .js-inner-back-btn click': function (el) {
            const target = $(el.context).closest('.js-inner-item');
            target.removeClass('is-expanded');
        },

        '.s-header .js-autorisation-title click': function (el) {
            const target = $(el.context).closest('.js-nav-item-autorisation');
            target.addClass('is-expanded');
        },

        '.s-header .js-autorisation-back click': function (el) {
            const target = $(el.context).closest('.js-nav-item-autorisation');
            target.removeClass('is-expanded');
        },

        '.s-header .js-hamburger-btn click': function (el) {
            context.$header.toggleClass('is-expanded', true);
            appContext.model.dispatch('page-scroll-toggle', [true]);
            el.attr('aria-expanded', 'true');

        },

        '.s-header .js-overlapping, .s-header .js-hamburger-close click': function () {
            context.$header.toggleClass('is-expanded', false);
            appContext.model.dispatch('page-scroll-toggle', [false]);
            const target = context.$header.find('.js-hamburger-btn');
            target.attr('aria-expanded', 'false');

            if (context.expandedItemIndex != null) {
                context.itemClick(context.expandedItemIndex);
            }
        },
    }],

    itemClick: function (targetIndex) {
        $(this.navItemsMap[targetIndex]).toggleClass('is-expanded');
        this.expandedItemIndex != null && targetIndex != this.expandedItemIndex && $(this.navItemsMap[this.expandedItemIndex]).removeClass('is-expanded');
        this.expandedItemIndex = this.expandedItemIndex === targetIndex ? null : targetIndex;
        this.$moreItem.removeClass('is-expanded');
    },

    '.s-header .js-gigya-btn click': function (el) {
        const action = $(el.context).data('action');
        if (!this.isGigyaAction(action) || Gigya.isReady()) {
            this.invokeAction(action);
        }
        else {
            this.invokableAction = action;
        }
    },

    '.ticker-dropdown change': function (el, ev) {
        LocalStorageService.setItem('ticker-championship', this.tickerData.find(({tickerSrc}) => tickerSrc === $(el).val()).championshipName);
        $(this.$tickerIframe).attr('src', $(el).val());
    },

    '.s-header .js-form-search submit': function (el, ev) {
        ev.preventDefault();

        const query = el.find('.js-fieldset__input').val();

        if (!query) {
            return;
        }

        dtm.trackGlobalNavigationSearchForTerms(query);

        const encodedQuery = encodeURIComponent(query);

        let baseUrl = urlUtil.getBaseUrl(),
            pathName = urlUtil.getPathName().trim().replace(/^\//, ''),
            hash = `#!&q=${encodedQuery}`,
            relativeUrl = `/${searchPagePath}`,
            absoluteUrl = '';

        if (urlUtil.isFullPath(searchPagePath)) {
            absoluteUrl = searchPagePath.split('#')[0] + hash;
        } else {
            absoluteUrl = baseUrl + (relativeUrl + hash).replace(/\/+/, '/');
        }

        if (!pathName || searchPagePath.indexOf(pathName) === -1) {
            location.assign(absoluteUrl);
        } else {
            urlUtil.pushState(absoluteUrl);
            appContext.model.dispatch('hamburger-search', [encodedQuery]);
        }
    },

    '.s-header .s-cell click': function (el, event) {
        if (!$(event.target).is('.s-dropdown, .s-dropdown *')) {
            if (!el.is('.hover')) {
                this.sCellActiveEl && this.sCellActiveEl.removeClass('hover');
                this.sCellActiveEl = el;
                el.addClass('hover');
            } else {
                el.removeClass('hover');
                this.sCellActiveEl = null;
            }

            if (el.hasClass('s-cell--autorisation')) {
                dtm.trackGlobalNavigationProfileIconClick();
            }

            if (el.hasClass('s-cell--search')) {
                dtm.trackGlobalNavigationSearchIconClick();
            }
        }
    },

    sCellhandleBodyClick: function (el, event) {
        if (this.sCellActiveEl && !$(event.target).is('.s-header .s-cell, .s-header .s-cell *')) {
            this.sCellActiveEl.removeClass('hover');
            this.sCellActiveEl = null;
        }
    },

    '{document.body} mousedown': function (el, event) {
        return this.sCellhandleBodyClick(el, event);
    },
    '{document.body} touchstart': function (el, event) {
        return this.sCellhandleBodyClick(el, event);
    },

    onWindowScroll: function () {
        this.checkScroll();
    },

    checkScroll: function () {
        let offset = this.$element.outerHeight();
        let scrollTop = window.pageYOffset;

        this.sendMessageToIframe();

        this.$element
            .attr('data-is-scrolling', scrollTop > offset)
            .attr('data-scroll-direction', this.screen.attr('scrollDirection'));
    },
});
